import { FaPlus } from 'react-icons/fa';
import { useState } from 'react'
import { useSelector } from "react-redux";
import Modal from 'react-bootstrap/Modal';
import SchedaSpeseForm, { CREATE_SCHEDA_FORM_ID } from '../components/SchedaSpeseForm';
import SchedaSpese from '../components/SchedaSpese';


function DashboardSchedaSpese() {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const { user } = useSelector((state) => state.auth);

  const handleClose = () => {
    setShow(false); // Reset Redux state when closing the modal
  };

  return (
    <>
      {user &&
        <div className="container">
          <div className="row">
            {/* <div className="col-12 col-md-8 m-auto">
              <div className='d-flex justify-content-between align-items-center mb-4 mt-0'>
                <h2 className='mb-0 align-self-center'>Expence list</h2>
                <div className=" btn bg-gradient-dark mb-0" onClick={handleShow}>
                  <p className="mb-0">
                    Create list
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      }

          <div className="container ">
            <div className="row">
              <div className="col-12 col-md-8 m-auto">
                <><SchedaSpese handleShow={() => handleShow()} /></>
              </div>
            </div>
          </div>
        {/* ) : (
          <>
 <div className="container">
              <div className="row">
                <div className="col-12 col-md-8 m-auto">
                  <h5>Create a new list</h5>
                  <p>Expence list are empty, create a list to start your budget</p>
                  <div className="col-3">
                    <div className="btn bg-gradient-dark" onClick={handleShow}>
                      <p className="mb-0">
                        Create list
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div> 
          </>
        )} */}


      <Modal
        show={show}
        onHide={handleClose}
        centered
        contentClassName="create-list-modal-content"
      >
        <Modal.Header closeButton className="create-list-modal-header">
          <div className="d-flex align-items-center gap-3">
            <div className="create-list-modal-icon">
              <FaPlus size={16} />
            </div>
            <div>
              <Modal.Title className="create-list-modal-title">
                Create new list
              </Modal.Title>
              <p className="create-list-modal-subtitle mb-0">
                Start a new expense sheet, personal or shared.
              </p>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="create-list-modal-body">
          <SchedaSpeseForm onSuccess={handleClose} formId={CREATE_SCHEDA_FORM_ID} />
        </Modal.Body>
        <Modal.Footer className="create-list-modal-footer">
          <button
            type="button"
            className="dashboard-btn-secondary"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            form={CREATE_SCHEDA_FORM_ID}
            className="dashboard-btn-primary"
          >
            Create
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DashboardSchedaSpese